import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { PopoverComponent } from "../../../shared/popover/popover.component";
import { FilterType } from "../../../models/enums";
import { Filter } from "../../../models/event/filter";
import { FilterService } from "../../../services/filter.service";
import { LineService } from "../../../services/line.service";
import { AutoUnsubscribe } from "../../../shared/decorators";
import { Helper } from "../../../shared/helper";

@Component({
  standalone: false,
  selector: "dua-line-number-filter",
  templateUrl: "./line-number-filter.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./../filters.component.scss"],
})
@AutoUnsubscribe()
export class LineNumberFilterComponent implements OnInit, OnDestroy {
  @ViewChild("popover") popover!: PopoverComponent;

  lineNumberDisplayValue = "";
  defaultTitle = "Samtliga linjer";
  open = false;
  filterType = FilterType.Line;
  lineNumbers: string[] = [];

  resetSubscription!: Subscription;
  lineNumberChangeSubscription!: Subscription;
  linesSubscription!: Subscription;
  currentOpenSubscription!: Subscription;

  constructor(
    private filterService: FilterService,
    private lineService: LineService
  ) {}

  ngOnInit(): void {
    this.lineNumberDisplayValue = this.defaultTitle;

    this.linesSubscription = this.lineService.getLines().subscribe((lines) => {
      this.lineService.setLineNumbers(lines);
      this.lineNumbers = lines.map((x) => x.name);
      this.setDisplayValue(this.filterService.getFilter().lines);
    });

    this.lineNumberChangeSubscription = this.filterService
      .getFilterChanges()
      .subscribe((change: Filter) => {
        this.setDisplayValue(change?.lines);
      });

    this.currentOpenSubscription = this.filterService
      .getCurrentOpenedFilterChanged()
      .subscribe((filterType) => {
        if (filterType != this.filterType) {
          this.closePopover();
        }
      });

    this.resetSubscription = this.filterService
      .getResetFilterTrigger()
      .subscribe(() => {
        this.lineNumberDisplayValue = this.defaultTitle;
      });
  }

  onToggle(payload: { open: boolean; event: Event }) {
    this.popover?.toggle(payload.event);
  }

  onPopoverShow() {
    this.open = true;
    this.filterService.setCurrentFilterType(this.filterType);
  }

  onPopoverHide() {
    this.open = false;
  }

  closePopover() {
    this.popover?.hide();
    this.open = false;
  }

  private setDisplayValue(lines: string[]) {
    if (this.isAllLineNumbers(lines) || !lines?.length) {
      this.lineNumberDisplayValue = this.defaultTitle;
    } else {
      this.lineNumberDisplayValue = lines.join(",");
    }
  }

  private isAllLineNumbers(lines: string[]) {
    return Helper.compareStringArrays(lines, this.lineNumbers);
  }

  ngOnDestroy() {}
}
